import type { FaireProductEntity } from "../../entity_types/product";

export const p_3j6pbw6guv: FaireProductEntity = {
  token: "p_3j6pbw6guv",
  type: "product",
  name: "Sherpa Baby Moccasins - Leather Baby Shoes (Desert Rose)",
  brandToken: "b_5ytgyrzl",
  brandName: "BirdRock Baby",
  imageUrl:
    "https://cdn.faire.com/fastly/21d54a71f6ff582001eff4d4ab125ad6c693d412a2640d776c30f7ee1c41eb4f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0d64b40dcb442d1186eb07b4139016babd2912e53691e69c558779e54a35f356.jpeg",
    "https://cdn.faire.com/fastly/6acd880982825426d624fb3145db05f48e347a9ac1544f966d03ce30810216a6.jpeg",
    "https://cdn.faire.com/fastly/4f9320cb224f5a8be02f7e0f80eaa46181891c831bf475bf8194d471ce7a9f31.jpeg",
  ],
  priceDollars: 17.5,
  description:
    'Our new Sherpa Moccasins have arrived! These cozy moccs are adorable and will be sure to keep little toes warm and snuggly through the winter months.\n\nSizing: \nUS 2 (0-6 Months, 3.75" Sole)\nUS 3 (3-6 Months; 4.125" Sole) \nUS 4 (6-12 Months, 4.5" Sole)\nUS 5.5 (12-18 Months, 5.0" Sole)\nUS 6.5 (18-24 Months, 5.25" Sole)\nUS 8 (2-3 Years, 5.75" Sole)\n',
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:02.412Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
